import { render } from "./CategorisedList.vue?vue&type=template&id=53326e90"
import script from "./CategorisedList.vue?vue&type=script&lang=js"
export * from "./CategorisedList.vue?vue&type=script&lang=js"

import "./CategorisedList.vue?vue&type=style&index=0&id=53326e90&lang=css"

import exportComponent from "/home/forge/fortiuspro.onlinesolutionsltd.com/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__